import { render, staticRenderFns } from "./AboutTitleBlock.vue?vue&type=template&id=7a031319"
import script from "./AboutTitleBlock.vue?vue&type=script&lang=js"
export * from "./AboutTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutTitleBlock.vue?vue&type=style&index=0&id=7a031319&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports